(function() {

    module.exports = {
        init: init,
    }

    var globals = require("./modules/globals.js")
    var chapterController = require("./chapter.js")
    var archiveUtils = require ("./archive.js")
    var heatmapControls = require("./modules/heatmapControls.js")
    var subtitleUtils = require("./modules/subtitle.js")
    var utils = require("./modules/utils.js")
    var header = false;
    var mobileMenu = false;
    var lang;

    var appData;

    function init(data) {
        appData = data;
        console.log(appData)
        routie({
            '':landing,
            '/:lang': landing,
            '/:lang/intro/:page': intro,
            '/:lang/home': home,
            '/:lang/home/?:params': archive,
            '/:lang/chapter/:chap': chapter,

        })


    }

    function landing(l) {
        lang = l!=undefined ? l : 'en'
        loadPage('landing', appData.copy[lang])
        addHeader(lang)
    }

    function intro(l, page) {
        lang = l!=undefined ? l : 'en'
        template = 'intro_'+page;
        loadPage(template, appData.copy[lang]);
        addHeader(lang, true)

    }

    function home(l) {
        lang = l != undefined ? l : 'en'
        chapters = chapterTitles(lang, appData.chapter_slides)
        appData.copy[lang]['_chapters'] = chapters
        for (c in appData.categories) {
            appData.categories[c].name = appData.copy[lang][appData.categories[c].link]
        }
        if (lang == 'es') {
            for (a in appData.archive) {
                appData.archive[a].Title = appData.archive[a].Title_es;
            }
        }
        appData.copy[lang]['categories'] = appData.categories
        loadPage('home', appData.copy[lang])
        addHeader(lang)

    }

    function archive(l, args) {
        lang = l!=undefined ? l : 'en'
        args = splitParams(args);
        console.log(args)
        if($("#take-action").length == 0) {
            home(l)
            setTimeout(function() {
                $('#main-view-container').scrollTop(2000)
                archiveSelect(args, lang)
            }, 700)
        }
        archiveSelect(args, lang)
    }

    function archiveSelect(args, lang) {
        if(args.audio) {
            appData.copy[lang]['currentCatLink'] = args.q;
            appData.copy[lang]['currentCatName'] = appData.categories.filter(function(l) { return l.link == args.q;})[0].name;
            appData.copy[lang]['currentAudio'] = args.audio;
            call = appData.archive.filter(function(l) { return l.Uid == args.audio});
            console.log(call)
            appData.copy[lang]['call'] = call;
            loadArchive('archive-call', appData.copy[lang])
        } else if(args.q) {
            calls = appData.archive.filter(function(l) { return containsVal(l.Categories, args.q)})
            appData.copy[lang]['calls'] = calls;
            appData.copy[lang]['currentCatLink'] = args.q;
            appData.copy[lang]['currentCatName'] = appData.categories.filter(function(l) { return l.link == args.q;})[0].name;
            loadArchive('archive-tags', appData.copy[lang])
        } else {
            loadArchive('archive', appData.copy[lang])
        }
    }

    function loadArchive(template, args) {
        $("#archive-container").fadeOut(function() {
            $.ajax({
                url: 'templates/'+template+'.html',
                cache: false
                // dataType: "json"
            }).done(function (data) {
                $("#archive-container").html(Mustache.render(data, args))
                $("#archive-container").fadeIn();
                if(template == 'archive-call') {
                    setTimeout(function() {
                        subtitleUtils.phoneScript('false');
                        el = document.getElementById('phoneline-intro');
                        el.play();
                    },1500)

                    playing = true;
                    $(".archive-play").click(function() {
                        if(playing) {
                            el.pause();
                            playing = false;
                            $(this).text('Play').addClass('play')
                        } else {
                            el.play();
                            playing = true;
                            $(this).text('Pause').removeClass('play')
                        }
                    })
                }
            })
        })
    }

    function splitParams(args) {
        ob = args.slice(1).split('&');
        output = {};
        for(p in ob) {
            v = ob[p].split('=')
            output[v[0]] = v[1]
        }
        return output;
    }

    function containsVal(lib, val) {

        contains = lib.filter(function(l) { return l == val})
        if(contains.length > 0 ) {
            return true
        } else {
            return false
        }
    }

    function chapter(l, chap) {
        lang = l!=undefined ? l : 'en'
        $('#main-view-container').scrollTop(0);
        createChapterTemplate(lang, chap)
        addHeader(lang)

    }

    function createChapterTemplate(lang, chap) {
  //      lang = la!=undefined ? la : 'en'

        chapterData = appData.chapter_slides.filter(function(l) { return l.chapterId == chap;});
        console.log(chapterData)
        if(lang == 'es') {
            for (d in chapterData) {
                chapterData[d].text = chapterData[d].text_ES;
                chapterData[d].altText = chapterData[d].altText_ES;
            }

            for(p in appData.people) {
                appData.people[p].title = appData.people[p].title_ES;
                appData.people[p].quote = appData.people[p].quote_es;
                appData.people[p].subtitle = appData.people[p].subtitle_es;
                appData.people[p].subtitle2 = appData.people[p].subtitle2_es;
            }
            for(t in appData.testimonies) {
                appData.testimonies[t].title = appData.testimonies[t].title_ES;
            }
        }
     //   chapterData.filter(function(l) { lang == 'en' ? l.text = l.text : l.text = l.text_ES;})
        result = ''
        $.when(
            $.get("templates/slide-titlePage.html"),
            $.get("templates/slide-text.html"),
            $.get("templates/slide-video.html"),
            $.get("templates/slide-audio.html"),
            $.get("templates/slide-personPage.html"),
            $.get("templates/slide-takeAction.html"),
            $.get("templates/slidesContainer.html"),
            $.get("templates/slide-nextChap.html"),
        ).then(function(title, text, video, audio, person, action, container, nextChap) {
            templates = {
                'title-page': title[0],
                'person-title': person[0],
                'text': text[0],
                'video': video[0],
                'audio': audio[0],
                'action': action[0],
                'container': container[0],
                'nextChap': nextChap[0]
            }

            vidSlide = chapterData.filter(function(s) { return s.type == 'video'})
            appData.copy[lang].vidUrl = vidSlide[0].backgroundMedia

            $("#main-view-container").fadeOut(function () {
                $("#main-view-container").html(Mustache.render(templates.container, appData.copy[lang]))
            });

            //           result = result + templates.container

            for (d in chapterData) {
                chapterData[d].i = d;
                if (chapterData[d].expert != '') {
                    testimony = appData.testimonies.filter(function (l) {
                        return l.uid == chapterData[d].expert;
                    })
                    chapterData[d]['testimony'] = testimony[0]
                    expert = appData.people.filter(function (l) {
                        return l.pid == chapterData[d].testimony.pid;
                    })
                    chapterData[d]['expertOption'] = expert[0]
                }
                if (chapterData[d].type == 'person-title') {
                    person = appData.people.filter(function (l) {
                        return l.pid == chapterData[d].text;
                    })
                    chapterData[d]['person'] = person[0]
                }
                if (chapterData[d].type == 'audio') {
                    //                  console.log(appData)
                    testimony = appData.testimonies.filter(function (l) {
                        return l.uid == chapterData[d].audioFile;
                    })
                    chapterData[d]['testimony'] = testimony[0]
                    person = appData.people.filter(function (l) {
                        return l.pid == chapterData[d].testimony.pid;
                    })
                    chapterData[d]['person'] = person[0]
                }
                template = templates[chapterData[d].type]
                chapterData[d].copy = appData.copy[lang]
                data = chapterData[d];

                slide = Mustache.render(template, data)
                result = result + slide;
            }
            if (parseInt(chap) < 4) {

                nextChapData = appData.chapter_slides.filter(function (s) {
                    return s.chapterId == parseInt(chap) + 1
                })[0]
                nextChapData.lang = lang;
                result = result + Mustache.render(templates.nextChap, nextChapData);
            }


            result = result + "<audio class=\"background-audio\" autoplay><source src=\"media/audio/"+chapterData[0].audioFile+".mp3\" type=\"audio/mp3\"></source></audio><div id='lastDiv'></div>";


            var timer = setInterval(function(){
                console.log("TIMER")
                if ($("#slides-container").length) {
                    console.log("ADD")
                    console.log(result)
                    $("#slides-container").html(result);
                    clearInterval(timer);
                }
            }, 200);

            var timer2 = setInterval(function() {
                if($("#lastDiv").length) {
                    $("#main-view-container").fadeIn(function () {
                        chapterController.init(appData, chap, lang)
                    })
                    clearInterval(timer2)
                }
            },200);


//            result = result + templates.action

//            result = result + "</div>"

/*            $("#main-view-container").fadeOut(function () {
                $("#main-view-container").html(result).fadeIn(function() {
                    chapterController.init();

                })
            })*/




        })


    }

    function chapterTitles(lang, data) {
        result = []
        current = 0;
        for (r in data) {
            if(current != data[r].chapterId) {
                if(lang == 'es') {
                    data[r].text = data[r].text_ES;
                    data[r].altText = data[r].altText_ES;
                }
                result.push(data[r])
                current = data[r].chapterId;
            }
        }
        result[0]['class'] = 'active slide-in'
        return result;
    }

    function loadPage(template, args) {
        mobileMenu = false;
        heatmapControls.stop();
        $("#main-view-container").fadeOut(function() {
            $.ajax({
                url: 'templates/'+template+'.html',
                cache: false
                // dataType: "json"
            }).done(function(data) {
                $("#main-view-container").html(Mustache.render(data, args));
                $("#main-view-container").fadeIn();
                // console.log(template)
                switch (template) {
                    case 'landing':
                        $("#ambient-background").prop('volume', 0)
                        $("#ambient-background")[0].play()
                        $("#ambient-background").animate({volume:1},2000)
                        break;
                    case 'intro_1':
                        $("#ambient-background").animate({volume:0},2000)
                        heatmapControls.init();

                        $("#welcome-note-cont").scroll(function() {
                            if ($("#welcome-note-cont").scrollTop() > 20) {
                                heatmapControls.start();
                            }
                            ;
                        }).scrollTop(0);
                        $("#continue-btn").click(function() {
                            heatmapControls.stop();
                            $(".intro-container").fadeOut()
                            $(".content-container.intro2").fadeIn()
                            subtitleUtils.phoneScript();
                            el = document.getElementById('phoneline-intro');
                            el.play();
                        })
                        break;
                    case 'intro_2':
                        subtitleUtils.phoneScript();
                        el = document.getElementById('phoneline-intro');
                        el.play();
                        break;
                    case 'home':
                        $("#next-chapter-btn").click(function() {
                            archiveUtils.nextChap();
                        });

                        $("#prev-chapter-btn").click(function() {
                            archiveUtils.prevChap()
                        });
                        $("#ambient-background").prop('volume', 0)
                        $("#ambient-background")[0].play()
                        $("#ambient-background").animate({volume:1},1000)
                        $(".call-now-button").click(function() {
                            utils.loadPopUp('callNow', appData.copy[lang])
                        })
     /*                   $(".archive-tag").click(function() {
                            $("#archive-container").fadeOut(function() {
                                $.ajax({
                                    url: 'templates/archive-tags.html',
                                    cache: false
                                    // dataType: "json"
                                }).done(function (data) {
                                    $("#archive-container").html(Mustache.render(data, []))
                                    $("#archive-container").fadeIn();
                                    $(".archive-call").click(function(){
                                        $("#archive-container").fadeOut(function() {
                                            $.ajax({
                                                url: 'templates/archive-call.html',
                                                cache: false
                                            }).done(function (data) {
                                                $("#archive-container").html(Mustache.render(data, []))
                                                $("#archive-container").fadeIn();
                                                subtitleUtils.phoneScript();
                                                el = document.getElementById('phoneline-intro');
                                                el.play();
                                            })
                                        })
                                    })
                                })
                            })
                        })*/

                }
            });
        });
    }

    function addHeader(lang, force) {
        force = force != '' ?  true : false;
        globals.lang = lang;
        if(force == true || header == false) {
            $.ajax({
                url: 'templates/header.html',
                cache: false
                // dataType: "json"
            }).done(function (template) {
                $(".header").html(Mustache.render(template, appData.copy[lang]))
                var headerTimer = setInterval(function(){
                    if ($("#credits-btn").length) {
                        $("#about-btn").click(function() {
                            utils.loadPopUp('about', appData.copy[lang]);
                        })

                        $("#credits-btn").click(function() {
                            utils.loadPopUp('credits', appData.copy[lang]);
                        })

                        $("#mobile-menu-btn img").click(function() {
                            if(mobileMenu == false) {
                                utils.loadMobileMenu(appData.copy[lang]);
                                mobileMenu = true;
                            } else {
                                $("#mobile-menu-container").fadeOut();
                                mobileMenu = false;
                            }
                        })
                        clearInterval(headerTimer);
                    }
                }, 200);

            });
            header = true;
        }
    }

})();